































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { List, Checkbox, CheckboxGroup, Button } from 'vant';
import SearchInput from './SearchInput.vue';
import PickerInput from './PickerInput.vue';
import VoteButton from '@/components/VoteButton.vue';
import { getlist } from '../api/index';
import { Icon } from 'vant';

Vue.use(Icon);
Vue.use(List).use(Checkbox).use(CheckboxGroup).use(Button);
@Component({
  components: {
    SearchInput,
    VoteButton,
    PickerInput,
  },
})
export default class VoteList extends Vue {
  @Prop() options!: any;
  @Prop() street!: string;
  loading = false;
  finished = false;
  page = 1;
  getListData: any[] = [];
  result = [];
  SearchData = '';
  pikerDataA = [
    '全部',
    '鸳鸯街道',
    '人和街道',
    '天宫殿街道',
    '翠云街道',
    '大竹林街道',
    '礼嘉街道',
    '金山街道',
    '康美街道',
    '龙兴园区',
    '鱼复园区',
    '水土园区',
    '其他',
  ];
  pikerDataB = ['全部', '创新创业', '文明风尚'];
  listType: string = '0';
  // 初使加载
  onLoad() {
    setTimeout(() => {
      getlist(
        this.options.voteName,
        this.page,
        this.street,
        this.listType,
      ).then((res: any) => this.fetchListData(res));
    });
  }
  fetchListData(res: any) {
    if (res.status === 1 || res.msg === '暂无数据') {
      this.finished = true;
    } else {
      this.getListData = [...this.getListData, ...res.data];
      this.page = this.page + 1;
    }
    this.loading = false;
  }
  // 进入详情页
  enterDetailPage(item: any) {
    // this.$router.push({ path: './DetailPage', query: { id: item.id } });
    this.$emit('enterDetailPage', { id: item.Id, type: item.type });
  }
  // 多选
  chooseOpus() {
    // bus.$emit('testF', this.result);
  }
  fetchSearch(e: any) {
    this.SearchData = e;
  }
  // 开始搜索;
  startSearch() {
    if (this.SearchData) {
      this.page = 1;
      this.getListData = [];
      // this.street = '0';
      // this.listType = '0';
      getlist(this.options.voteName, this.page, '0', '0', this.SearchData).then(
        (res: any) => this.searchNewsData(res),
      );
    } else {
      this.getListData = [];
      this.page = 1;
      this.finished = false;
      setTimeout(() => {
        this.onLoad();
      }, 500);
    }
  }

  searchNewsData(res: any) {
    this.getListData = [...this.getListData, ...res.data];
    this.finished = true;
  }
  selectDataA(e: any, index: number) {
    if (e === '全部') {
      this.listType = '0';
      return;
    }
    this.listType = e;
  }
  selectDataB(e: any, index: number) {
    if (e === '全部') {
      this.street = '0';
      return;
    }
    this.street = e;
  }
  @Watch('listType')
  onListTypeChanged() {
    this.page = 1;
    this.getListData = [];
    this.finished = false;
    this.loading = true;
    this.onLoad();
  }
  @Watch('street')
  onStreetChanged() {
    this.page = 1;
    this.getListData = [];
    this.finished = false;
    this.loading = true;
    this.onLoad();
  }
}
